/**
 * Where the desktop app's own backend is listening, if there is one.
 *
 * Electron exposes this on `window.lvbDesktop`. In a browser it is absent, and
 * in the desktop app it is present from startup.
 *
 * Two functions rather than one, because callers genuinely differ:
 *
 * - `localBackendUrl()` for callers that work either way and decide for
 *   themselves what to do without it — the map and routing asset panels report
 *   "not installed", the authenticated client falls back to the cloud;
 * - `requireLocalBackendUrl()` for callers that are meaningless without it —
 *   writing an offline order has nowhere to go if the local backend is missing,
 *   so failing loudly beats sending the request somewhere unintended.
 *
 * The throwing form was written out inline fourteen times in `orders.js` alone.
 *
 * See TCA-26081301.
 */

export const localBackendUrl = () => (
  typeof window !== 'undefined'
    ? window.lvbDesktop?.localBackendUrl
    : null
);

export const requireLocalBackendUrl = () => {
  const url = localBackendUrl();
  if (!url) {
    throw new Error('Local desktop backend is unavailable');
  }
  return url;
};
